import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { can } from '../../utils/auth';
import styles from './ContractApprovalOptions.style';
import ContractApprovalDialog from '../ContractApprovalDialog';

import { approve, reject } from '../../actions/contracts';

import useAPI from '../../hooks/useAPI';

const ContractApprovalOptions = ({ contractAddress, isEdit }) => {
  const [showContractApprovalDialog, setShowContractApprovalDialog] = useState(false);
  const [showContractRejectionDialog, setShowContractRejectionDialog] = useState(false);

  const onApproveContract = () => {
    setShowContractApprovalDialog(true);
  };

  const onRejectContract = () => {
    setShowContractRejectionDialog(true);
  };

  const onDismissApprovalDialog = () => {
    setShowContractApprovalDialog(false);
  };

  const onDismissRejectionDialog = () => {
    setShowContractRejectionDialog(false);
  };

  const onSuccessCallback = () => {
    setShowContractApprovalDialog(false);
    setShowContractRejectionDialog(false);
  };

  const approveApi = useAPI(
    () => {
      return approve(contractAddress, isEdit);
    },
    [contractAddress],
    {
      fetchOnMount: false,
      autoFetch: false,
      onSuccessCallback,
    },
  );

  const rejectApi = useAPI(
    values => {
      const { rejectReason } = values;
      return reject(contractAddress, isEdit, { rejectReason });
    },
    [contractAddress],
    {
      fetchOnMount: false,
      autoFetch: false,
      onSuccessCallback,
    },
  );

  const onApproveSubmit = async () => {
    await approveApi.fetchApi();
  };

  const onRejectSubmit = async values => {
    await rejectApi.fetchApi(values);
  };

  return (
    <>
      {showContractApprovalDialog && (
        <ContractApprovalDialog
          isApproved
          error={approveApi.error}
          isSubmitting={approveApi.isLoading}
          onSubmit={onApproveSubmit}
          isOpen={showContractApprovalDialog}
          onDismiss={onDismissApprovalDialog}
          isEdit={isEdit}
        />
      )}
      {showContractRejectionDialog && (
        <ContractApprovalDialog
          isApproved={false}
          onSubmit={onRejectSubmit}
          isReasonRequired
          isSubmitting={rejectApi.isLoading}
          error={rejectApi.error}
          isOpen={showContractRejectionDialog}
          onDismiss={onDismissRejectionDialog}
          isEdit={isEdit}
        />
      )}
      <div>
        {can('approveContract') && (
          <PrimaryButton
            type="submit"
            onClick={onApproveContract}
            className={styles.actionButton}
            data-testid="approval-button"
          >
            Approve
          </PrimaryButton>
        )}
        {can('rejectContract') && (
          <DefaultButton
            onClick={onRejectContract}
            className={styles.actionButton}
            data-testid="rejection-button"
          >
            Reject
          </DefaultButton>
        )}
      </div>
    </>
  );
};

ContractApprovalOptions.propTypes = {
  contractAddress: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default ContractApprovalOptions;
